import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../../../environments/environment";

@Injectable()
export class HttpHeaderUrlInterceptor implements HttpInterceptor {
    constructor(
    ) {

    }
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = this.overrideRequest(req);

        return next.handle(req);
    }

    private overrideRequest(req: HttpRequest<any>): HttpRequest<any> {
        const headers = req.url.includes('files') ? req.headers : req.headers.append('Content-Type', 'application/json');

        if (req.url.includes('assets') || req.url.includes('make.com')) {
            return req.clone({ headers });
        }

        return req.clone({ headers, url: `${environment.url}${req.url}` });
    }
}

export let HttpHeaderURLInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpHeaderUrlInterceptor,
    multi: true
};
